import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import JoinForm from './components/JoinForm';
import MeetingRoom from './components/MeetingRoom';

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<JoinForm />} />
                    <Route path="/:meetingId" element={<MeetingRoom />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;